import { PAGE_HOME_INCLUSIONE, PAGE_HOME_URL, PAGE_INCLUSIONE_LAB_IMPACT, PAGE_INCLUSIONE_RICONGIUNGIMENTO } from 'types/url';

export const BreadcrumbPath = [
  {
    slash: 'Home',
    url: PAGE_HOME_URL,
  },
  {
    slash: 'WeMi inclusione',
    url: PAGE_HOME_INCLUSIONE,
  },
  {
    slash: 'FAMI LAB\'IMPACT',
    url: PAGE_INCLUSIONE_LAB_IMPACT,
  },
];

export const title = 'WeMi - Inclusione - Fami lab\'impact';
export const description = 'Descrizione servizio Fami lab\'impact';
export const keywords = 'welfare, milano, servizi, servizio, WeMi Fami lab\'impact, servizio Fami lab\'impact, informazioni Fami lab\'impact, Fami lab\'impact';
